var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils } from './_default-imports';
//namespace Pacem.Components {
class EmitEvent extends Event {
    constructor(_originalEvent) {
        super('emit');
        this._originalEvent = _originalEvent;
    }
    get originalEvent() {
        return this._originalEvent;
    }
}
const ElementOrWindowConverter = {
    convert: function (attr, element) {
        if (attr === '$window') {
            return window;
        }
        return PropertyConverters.Element.convert(attr, element);
    },
    convertBack: (prop, element) => {
        if (prop === window) {
            return '$window';
        }
        return PropertyConverters.Element.convertBack(prop, element);
    }
};
let PacemEventProxyElement = class PacemEventProxyElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this._emitHandler = (evt) => {
            var event = new EmitEvent(evt);
            this.dispatchEvent(event);
        };
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._observe();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'target':
                    this._unobserve(old, this.event, this.capture);
                    this._observe();
                    break;
                case 'event':
                    this._unobserve(this.target, old, this.capture);
                    this._observe();
                    break;
                case 'capture':
                    this._unobserve(this.target, this.event, old);
                    this._observe();
                    break;
            }
        }
    }
    disconnectedCallback() {
        this._unobserve();
        super.disconnectedCallback();
    }
    _unobserve(target = this.target, event = this.event, capture = this.capture) {
        if (Utils.isNull(target) || Utils.isNullOrEmpty(event)) {
            return;
        }
        target.removeEventListener(event, this._emitHandler, { capture });
    }
    _observe(target = this.target, event = this.event, capture = this.capture) {
        if (Utils.isNull(target) || Utils.isNullOrEmpty(event)) {
            return;
        }
        target.addEventListener(event, this._emitHandler, { capture });
    }
};
__decorate([
    Watch({ emit: false, converter: ElementOrWindowConverter })
], PacemEventProxyElement.prototype, "target", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemEventProxyElement.prototype, "event", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemEventProxyElement.prototype, "capture", void 0);
PacemEventProxyElement = __decorate([
    CustomElement({
        tagName: P + '-event-proxy'
    })
], PacemEventProxyElement);
export { PacemEventProxyElement };
//}
